import { SupportedLocale } from "@intocare/datatypes/lib/i18n";

import { FallObservationReportData } from "./types";
import { createConfiguredPdf } from "../../shared/pdf-maker";
import { createDocumentContextFor } from "../templates/document-context";
import { getFallObservationDefinition } from "../templates/fall-observation-report";

export const generateFallObservationReport = (
	fallObservation: FallObservationReportData,
	locale: SupportedLocale,
	user?: string,
) => createConfiguredPdf(getFallObservationDefinition(createDocumentContextFor({ locale }), fallObservation, user));
